import "./style.scss";
import React, { useEffect } from "react";
import { Routes } from "./components/routes/Routes";
import { Toaster } from "react-hot-toast";
import GlobalLoader from "./components/loader/GlobalLoader";
function App() {
  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "logout") {
        sessionStorage.clear();
        window.location.href = process.env.REACT_APP_KEYCLOACK_POST_LOGOUT;
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);
  return (
    <>
      <GlobalLoader />
      <Toaster position="top-right" reverseOrder={false} />
      <Routes />
    </>
  );
}

export default App;
